import { SVGAttributes } from "react";

export const UnlinkIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.427 8.518a1.036 1.036 0 01-1.411-.014.914.914 0 01.014-1.34l1.356-1.26c.059-.055.177-.19.299-.378.456-.707.456-1.346-.3-2.048-.766-.713-1.485-.713-2.261-.28-.205.114-.35.225-.41.28L8.36 4.738a3.733 3.733 0 00-.64.828L6.266 4.188c.256-.356.51-.631.696-.804l1.355-1.26a4.2 4.2 0 01.796-.56c1.483-.827 3.175-.827 4.668.56 1.504 1.398 1.504 3 .604 4.392a3.976 3.976 0 01-.604.742l-1.355 1.26zM8.477 9.914l-1.969-1.87a.997.997 0 01-.223-.156 2.602 2.602 0 01-.328-.366L2.162 3.917c-.37-.35-.353-.935.037-1.305.39-.37 1.005-.386 1.374-.035l10.006 9.502c.369.35.352.934-.037 1.304-.39.37-1.005.386-1.374.036l-2.152-2.043c-.084.145-.178.289-.28.432a5.546 5.546 0 01-.699.808l-1.355 1.26c-.167.155-.436.36-.796.56-1.483.827-3.175.827-4.668-.56-1.504-1.398-1.504-3-.604-4.392a3.98 3.98 0 01.604-.742l1.355-1.26a1.036 1.036 0 011.411.014.914.914 0 01-.014 1.34l-1.356 1.26c-.058.055-.177.19-.299.378-.456.707-.456 1.346.3 2.048.766.713 1.485.713 2.261.28.205-.114.35-.225.41-.28l1.355-1.26c.1-.093.273-.28.445-.52.22-.309.358-.6.39-.828z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.538 12.19l2.069-2.069a3 3 0 10-4.243-4.242l-2.069 2.068-1.414-1.414 2.069-2.069a5 5 0 017.07 7.072l-2.068 2.068-1.414-1.414zM9.204 8.552a5.002 5.002 0 00.917 5.812 1 1 0 001.415-1.414 2.998 2.998 0 01-.789-2.854l3.035 3.034a2.996 2.996 0 01-.832 2.648l-2.829 2.829a3 3 0 11-4.242-4.243L8 12.243a1 1 0 10-1.414-1.415L4.464 12.95a5 5 0 007.072 7.07l2.828-2.828a4.977 4.977 0 001.283-2.197l3.81 3.81c.327.327.893.29 1.266-.082.372-.373.41-.94.083-1.266L6.939 3.591c-.326-.326-.893-.29-1.265.083-.372.372-.41.939-.083 1.265l3.613 3.613z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
UnlinkIcon.displayName = "UnlinkIcon";
